<template>
  <div id="shiori-title">
    <div id="title-top-text">
    <h1><span>旅</span>のしおり</h1>
      <p>『旅のしおり』へようこそ。<br>
      ここは、旅行のしおりが簡単に作れるサイトです。<br>しおりのタイトルを決めて早速作ってみよう！</p>
      <p style="font-size:16px; color:#EA4335;">※現在サイト作成中のため、保存・共有機能はありません。<br>
      リロードすると入力したデータはリセットされます。</p>
      <a @click.prevent="toHowTo" class="move-to-howto"><i class="fas fa-question "></i>使い方</a>
    </div>
    <div id="title-input">
      <h2>タイトル</h2>
      <h1>『 {{ shioriTitle }} 』</h1> <!--14文字まで-->
      <button @click="maskActive" id="title-cheng-btn">タイトルを変更する</button>
    </div>
    <div class="sub-footer" v-show="underNav">
      <p>© 2020 Tabi no Shiori</p>
    </div>
    <MovePageBtn  v-show="spWidth" 
    :next-page="{name:movePage.name, link:movePage.link}"></MovePageBtn>
    <MaskBox v-show="maskOn" ></MaskBox>
    <InputTitle 
    v-show="maskOn"  
    @cancel="maskActive" 
    @new-shiori-title="addNewTitle"></InputTitle>
  </div>
</template>

<script>
  import InputTitle from './InputBoxes/InputTitle.vue';

  export default {
    props: {
      spWidth: {
        type: Boolean,
        required: true
      },
      underNav: {
        type: Boolean,
        required: true
      }
    },
    components: {
      InputTitle
    },
    data() {
      return {
        movePage: {
          name: '概要',
          link: '/about',
        },
        maskOn: false,
      }
    },
    methods: {
      maskActive() {
        this.maskOn = !this.maskOn;
      },
      toHowTo() {
        this.$router.push("howto");
      },
      addNewTitle(value) {
        this.shioriTitle = value;
        this.maskOn = !this.maskOn;
      }
    },
    computed: {
      shioriTitle: {
        get() {
          return this.$store.getters.shioriTitle;
        },
        set(value) {
          this.$store.commit('shioriTitle', value);
        }
      },
    },
  }
</script>

<style>

</style>